export default __webpack_public_path__ + "static/media/img2-carousel.2fe14e9f.webp";